// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"4696c9a8","820":"06a2fb94"}[chunkId] + ".chunk.js";
};